<template>
    <div class="af-documents">
        <PageHeading>{{ $t('dashboard_menu.documents') }}</PageHeading>
        <Submenu
            :menu="submenu"
            @menuChange="changeTab"
        />
        <Resumes v-show="isResumesActive" />
        <CoverLetters v-show="isCoverLettersActive" />
        <AdditionalDocuments v-show="isAdditionalDocumentActive" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Submenu from '@/apps/dashboard/001/components/Submenu';
    import PageHeading from '@/apps/dashboard/001/components/PageHeading';
    import Resumes from '@/apps/dashboard/001/components/Resumes/Resumes';
    import CoverLetters from '@/apps/dashboard/001/components/CoverLetters/CoverLetters';
    import AdditionalDocuments from '@/apps/dashboard/001/components/AdditionalDocuments/AdditionalDocuments';

    export default {
        name: 'Documents',

        components: {
            CoverLetters,
            PageHeading,
            Submenu,
            Resumes,
            AdditionalDocuments,
        },

        data() {
            return {
                submenu: [],
            };
        },

        created() {
            let resumes = [];
            if (!this.$_seekerSectionByCode('resumes').is_hidden) {
                resumes = [
                    {
                        id: 'resumes',
                        label:
                            this.$_seekerFieldByCode('resumes').label ||
                            `${this.$t('label.resumes')}`,
                        is_active: false,
                    },
                ];
            }

            let cover_letters = [];
            if (!this.$_seekerSectionByCode('cover_letters').is_hidden) {
                cover_letters = [
                    {
                        id: 'cover_letters',
                        label:
                            this.$_seekerFieldByCode('cover_letters').label ||
                            `${this.$t('label.cover_letters')}`,
                        is_active: false,
                    },
                ];
            }

            let additional_doc = [];
            if (!this.$_seekerSectionByCode('additional_doc').is_hidden) {
                additional_doc = [
                    {
                        id: 'additional_doc',
                        label:
                            this.$_seekerFieldByCode('additional_doc').label ||
                            `${this.$t('label.additional_documents')}`,
                        is_active: false,
                    },
                ];
            }

            this.submenu = [...resumes, ...cover_letters, ...additional_doc];
            if (this.submenu[0]) {
                this.submenu[0].is_active = true;
            }
        },

        computed: {
            ...mapGetters('site', {
                $_seekerFieldByCode: 'seekerFieldByCode',
                $_seekerSectionByCode: 'seekerSectionByCode',
            }),

            isResumesActive() {
                const menu = this.findMenuById('resumes');
                return menu ? menu.is_active : false;
            },

            isCoverLettersActive() {
                const menu = this.findMenuById('cover_letters');
                return menu ? menu.is_active : false;
            },

            isAdditionalDocumentActive() {
                const menu = this.findMenuById('additional_doc');
                return menu ? menu.is_active : false;
            },
        },

        methods: {
            findMenuById(id) {
                return this.submenu.find(o => o.id === id);
            },

            changeTab(nav) {
                this.submenu.forEach(o => (o.is_active = nav.id === o.id));
            },
        },
    };
</script>
